import { COMPANY_ACTIONS } from "constants";

// Company Profile Actions
export function fetchCompanyProfile(companyId, caseId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_PROFILE,
        payload: {
            companyId,
            caseId
        }
    };
}

export function fetchedCompanyProfile(companyId, profile) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_PROFILE,
        payload: {
            companyId,
            profile
        }
    };
}

export function failedFetchCompanyProfile(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_PROFILE,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyProfile(companyId, profile) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_PROFILE,
        payload: {
            companyId,
            profile
        }
    };
}

export function updatedCompanyProfile(companyId, profile) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_PROFILE,
        payload: {
            companyId,
            profile
        }
    };
}

export function failedUpdateCompanyProfile(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_PROFILE,
        payload: {
            companyId
        },
        error
    };
}

//Company Associates Actions
export function fetchCompanyAssociates(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_ASSOCIATES,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyAssociates(companyId, associates) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_ASSOCIATES,
        payload: {
            companyId,
            associates
        }
    };
}

export function failedFetchCompanyAssociates(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ASSOCIATES,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyAssociates(companyId, associates, addresses = [], caseId , action , associateID) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES,
        payload: {
            companyId,
            associates,
            addresses,
            caseId,
            action,
            associateID
        }
    };
}

export function updatedCompanyAssociates(companyId, associates) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_ASSOCIATES,
        payload: {
            companyId,
            associates
        }
    };
}

export function failedUpdateCompanyAssociates(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ASSOCIATES,
        payload: {
            companyId
        },
        error
    };
}

// Associates Cibil Actions
export function updateCompanyAssociatesCibil(associateId, cibil, companyId) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES_CIBIL,
        payload: {
            associateId,
            cibil,
            companyId
        }
    };
}

export function updatedCompanyAssociatesCibil(associateId, cibil, companyId) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_ASSOCIATES_CIBIL,
        payload: {
            associateId,
            cibil,
            companyId
        }
    };
}

export function failedUpdateCompanyAssociatesCibil(associateId, error, companyId) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ASSOCIATES_CIBIL,
        payload: {
            associateId,
            companyId
        },
        error
    };
}

//Company Addresses Actions
export function fetchCompanyAddresses(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_ADDRESSES,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyAddresses(companyId, addresses) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_ADDRESSES,
        payload: {
            companyId,
            addresses
        }
    };
}

export function failedFetchCompanyAddresses(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ADDRESSES,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyAddresses(companyId) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESSES,
        payload: {
            companyId
        }
    };
}

export function updatedCompanyAddresses(companyId, addresses) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_ADDRESSES,
        payload: {
            companyId,
            addresses
        }
    };
}

export function failedUpdateCompanyAddresses(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ADDRESSES,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyAddress(companyId, type, address) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESS,
        payload: {
            companyId,
            address,
            type
        }
    };
}

export function updatedCompanyAddress(companyId, type, address) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_ADDRESS,
        payload: {
            companyId,
            type,
            address
        }
    };
}

export function failedUpdateCompanyAddress(companyId, type, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_ADDRESS,
        payload: {
            companyId,
            type
        },
        error
    };
}

// Company Bank Accounts Actions
export function fetchCompanyBankAccounts(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyBankAccounts(companyId, bankAccounts) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId,
            bankAccounts
        }
    };
}

export function failedFetchCompanyBankAccounts(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyBankAccounts(companyId, bankAccounts, caseId) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId,
            bankAccounts,
            caseId
        }
    };
}

export function updatedCompanyBankAccounts(companyId, bankAccounts) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId,
            bankAccounts
        }
    };
}

export function failedUpdateCompanyBankAccounts(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_BANK_ACCOUNTS,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanySingleAssociate(associate, address, fileObj, companyId, caseId , {validateFromCompany = null} = {}) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_ASSOCIATE,
        payload: {
            companyId,
            associate,
            address,
            fileObj,
            caseId,
            validateFromCompany
        }
    };
}

export function updatedCompanySingleAssociate(companyId, associate) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_SINGLE_ASSOCIATE,
        payload: {
            companyId,
            associate
        }
    };
}

export function failedUpdateCompanySingleAssociate(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_SINGLE_ASSOCIATE,
        payload: {
            companyId,
            error
        }
    };
}

export function updateCompanyMultipleAssociate(associate, companyId) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_MULTIPLE_ASSOCIATE,
        payload: {
            companyId,
            associate
        }
    };
}

export function updatedCompanyMultipleAssociate(companyId, associate) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_MULTIPLE_ASSOCIATE,
        payload: {
            companyId,
            associate
        }
    };
}

export function failedUpdateCompanyMultipleAssociate(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_MULTIPLE_ASSOCIATE,
        payload: {
            companyId,
            error
        }
    };
}

export function updateCompanySingleAddress(companyId, address, case_id) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_ADDRESS,
        payload: {
            companyId,
            address,
            case_id
        }
    };
}

export function updatedCompanySingleAddress(companyId, address) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_SINGLE_ADDRESS,
        payload: {
            companyId,
            address
        }
    };
}

export function failedUpdateCompanySingleAddress(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_SINGLE_ADDRESS,
        payload: {
            companyId,
            error
        }
    };
}

export function fetchCompanyGstinFillingDetails(gstin) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin
        }
    };
}

export function fetchedCompanyGstinFillingDetails(gstin, data) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin,
            data
        }
    };
}

export function failedFetchCompanyGstinFillingDetails(gstin, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin
        },
        error
    };
}

export function refreshCompanyGstinFillingDetails(gstin, companyId) {
    return {
        type: COMPANY_ACTIONS.REFRESH_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin,
            companyId
        }
    };
}

export function refreshedCompanyGstinFillingDetails(gstin, data) {
    return {
        type: COMPANY_ACTIONS.REFRESHED_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin,
            data
        }
    };
}

export function failedRefreshCompanyGstinFillingDetails(gstin, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_REFRESH_COMPANY_GSTIN_FILLING_DETAILS,
        payload: {
            gstin
        },
        error
    };
}

export function updateCompanySingleBankAccount(companyId, bankAccount) {
    return {
        type: COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_BANK_ACCOUNT,
        payload: {
            companyId,
            bankAccount
        }
    };
}

export function updatedCompanySingleBankAccount(companyId, bankAccount) {
    return {
        type: COMPANY_ACTIONS.UPDATED_COMPANY_SINGLE_BANK_ACCOUNT,
        payload: {
            companyId,
            bankAccount
        }
    };
}

export function failedUpdateCompanySingleBankAccount(companyId, error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_COMPANY_SINGLE_BANK_ACCOUNT,
        payload: {
            companyId,
            error
        }
    };
}

// Company Checklist
export function fetchCompanyChecklist(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_CHECKLIST,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyChecklist(companyChecklist) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_CHECKLIST,
        payload: {
            data  : companyChecklist
        }
    };
}

export function failedFetchCompanyChecklist(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_CHECKLIST,
        error
    };
}


// Company Notes
export function fetchCompanyNotes(actionDetailId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_NOTES,
        payload: {
            actionDetailId
        }
    };
}

export function fetchedCompanyNotes(companyNotes) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_NOTES,
        payload: {
            count : companyNotes.count,
            data  : companyNotes.results
        }
    };
}

export function failedFetchCompanyNotes(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_NOTES,
        error
    };
}

// Create Company Notes
export function createCompanyNotes(companyNote) {
    return {
        type: COMPANY_ACTIONS.CREATE_COMPANY_NOTE,
        payload: {
            companyNote
        }
    };
}

export function fetchedCreateCompanyNotes() {
    return {
        type: COMPANY_ACTIONS.FETCHED_CREATE_COMPANY_NOTE,
    };
}

export function failedCreateCompanyNotes(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_CREATE_COMPANY_NOTE,
        error
    };
}

//fetch Case associates and address V23

export function fetchCompanyAssociatesV2(caseId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_ASSOCIATES_V2,
        payload: {
            caseId
        }
    };
}

export function fetchedCompanyAssociatesV2(data) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_ASSOCIATES_V2,
        payload : {
            data : data
        }
    };
}

export function failedFetchCompanyAssociatesV2(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ASSOCIATES_V2,
        error
    };
}

// Update and approve MPA details

export function updateMpaDetails(data, mpaId, loaderFor) {
    return {
        type: COMPANY_ACTIONS.UPDATE_MPA_DETAILS,
        payload: {
            data, 
            mpaId,
            loaderFor
        }
    };
}

export function updatedMpaDetails(loaderFor) {
    return {
        type: COMPANY_ACTIONS.UPDATED_MPA_DETAILS,
        payload : {
            loaderFor
        }
    };
}

export function failedUpdateMpaDetails(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_UPDATE_MPA_DETAILS,
        error
    };
}

//fetch Company all Mpa / Cases listing for company 

export function fetchCompanyAllMpa(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_COMPANY_ALL_MPA,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyAllMpa(data) {
    return {
        type: COMPANY_ACTIONS.FETCHED_COMPANY_ALL_MPA,
        payload : {
            data : data
        }
    };
}

export function failedFetchCompanyAllMpa(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_COMPANY_ALL_MPA,
        error
    };
}

export function clearCompanyAllMpa() {
    return {
        type: COMPANY_ACTIONS.CLEAR_COMPANY_ALL_MPA,
    };
}


export function fetchEnums(companyId) {
    return {
        type: COMPANY_ACTIONS.FETCH_ENUMS,
        payload: {
            companyId
        }
    };
}

export function fetchedEnums(data) {
    return {
        type: COMPANY_ACTIONS.FETCHED_ENUMS,
        payload : {
            data : data
        }
    };
}

export function failedFetchEnums(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_ENUMS,
        error
    };
}
export function fetchPanAadharLink(caseId, associateId) {
    return {
        type: COMPANY_ACTIONS.FETCH_PAN_AADHAR_LINK,
        payload: {
            caseId,
            associateId
        }
    };
}

export function fetchedPanAadharLink(data) {
    return {
        type: COMPANY_ACTIONS.FETCHED_PAN_AADHAR_LINK,
        payload : {
            data : data
        }
    };
}

export function failedFetchPanAadharLink(error) {
    return {
        type: COMPANY_ACTIONS.FAILED_FETCH_PAN_AADHAR_LINK,
        error
    };
}
